import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService } from './theme.service';

@Component({
  selector: 'fl-theme',
  standalone: true,
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeComponent implements OnInit, OnDestroy {
  private themeService = inject(ThemeService);
  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.themeService.theme$
        .pipe()
        .subscribe(theme => this.themeService.applyTheme(theme)),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
